import { render } from "./HeaderMessage.vue?vue&type=template&id=5dfe8642"
import script from "./HeaderMessage.vue?vue&type=script&lang=js"
export * from "./HeaderMessage.vue?vue&type=script&lang=js"
script.render = render

export default script